import { Divider, Grid2, Typography } from "@mui/material";

const SimpleLoader = () => {
  return (
    <Grid2
      container
      justifyContent={"center"}
      alignItems={"center"}
      flexDirection={"column"}
      minHeight={"100%"}
      bgcolor={"var(--white)"}
      borderRadius={2}
      border={`1px solid var(--neutral-100)`}
    >
      <img
        style={{
          borderRadius: 3,
          filter: `drop-shadow(0px 0px 3px var(--primary-900))`,
        }}
        src="/Logos/GridkeyGif.gif"
        alt=" "
        height={80}
        width={80}
      />
      <Divider
        sx={{
          width: "60%",
        }}
      />

      <Typography fontSize={12} fontWeight={700} color={"var(--neutral-500)"}>
        Hold on ! We are fetching Data.
      </Typography>
    </Grid2>
  );
};

export default SimpleLoader;
